import http from './http';
import { IAccount, IFilter, IRetentionConfig } from '../resource';

export interface UserQueryParams {
  archived?: number;
  page?: number;
  limit?: number;
  [key: string]: any;
}

export const createUser = async (user: IAccount) => {
  return await http.post('/users', user);
};

export const getUsers = async (filter?: IFilter & UserQueryParams, options?: { signal?: AbortSignal }) => {
  return await http.get('/users', filter, {}, options?.signal);
};

export const getUser = async (id: string) => {
  return await http.get(`/users/${id}`);
};

export const updateUser = async (id: string, user) => {
  return await http.put(`/users/${id}`, user);
};

export const removeUser = async (id: string) => {
  return await http.delete(`/users/${id}`);
};

export const removeUsers = async (ids: string[]) => {
  return await http.delete('/users', { ids });
};

export const getRetentionConfig = async (userId: string): Promise<{ success: boolean; retentionConfig: IRetentionConfig }> => {
  return await http.get(`/users/${userId}/retention-config`);
};

export const updateRetentionConfig = async (userId: string, config: IRetentionConfig): Promise<{ success: boolean; retentionConfig: IRetentionConfig }> => {
  return await http.put(`/users/${userId}/retention-config`, config);
};

export const removeUserForever = async (userId: string): Promise<{ success: boolean, msg: string }> => {
  return await http.delete(`/users/${userId}/delete-forever`);
};

export const recoverUser = async (userId: string): Promise<{ success: boolean, msg: string }> => {
  return await http.put(`/users/${userId}/recover`);
};
